<script setup lang="ts">
import { getVipBenefitSectionServices } from "~/composables/badges";

let benefits = await getVipBenefitSectionServices();
</script>

<template>
  <div class="mt-20">
    <div class="bg-lavender-blush-50 relative py-10">
      <nuxt-img
        src="images/background.png"
        alt="background"
        format="webp"
        class="bg-transparent xl:block hidden bg-cover pt-10 pb-8"
        width="602"
        height="819"
      />
      <div
        class="xl:absolute text-center text-cerise-red-600 w-full pt-10 px-10 pb-16 top-10 font-extrabold text-xl leading-6 lg:text-3xl lg:leading-9"
      >
        Ti iscrivi e ottieni subito tanti servizi esclusivi
      </div>
    </div>

    <div
      class="xl:container xl:-mt-[806px] relative px-5 py-5 bg-lavender-blush-50 xl:bg-transparent"
    >
      <div
        class="grid justify-items-center xl:place-items-stretch lg:grid-cols-2 xl:grid-cols-3 lg:gap-x-7 lg:gap-y-6 lg:py-12"
      >
        <template v-for="(item, i) in benefits">
          <HomepageVipBenefitCard
            :title="item.title"
            :description="item.description"
            :imageSrc="item.icon"
            type="random"
            :class="[
              i !== 0 ? 'my-8 lg:my-6' : 'mb-8 lg:my-6',
              { 'mb-14 ': i === benefits.length - 1 },
            ]"
          />
        </template>
      </div>
      <div class="flex justify-center items-center">
        <nuxt-link to="/login" target="_blank">
          <CorePrimaryButton>
            ACCEDI ALLA TUA AREA PERSONALE
          </CorePrimaryButton>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
